export const ClearLocalStorageAll = () => {
  localStorage.removeItem('Alamat')
  localStorage.removeItem('BlnLahir')
  localStorage.removeItem('Cabang')
  localStorage.removeItem('Email')
  localStorage.removeItem('Gaji')
  localStorage.removeItem('JHT')
  localStorage.removeItem('JamKeluarKantor')
  localStorage.removeItem('JamMasukKantor')
  localStorage.removeItem('Kota')
  localStorage.removeItem('NIK')
  localStorage.removeItem('NamaLengkap')
  localStorage.removeItem('NoPonsel')
  localStorage.removeItem('NoVerifikasiSMS')
  localStorage.removeItem('Pekerjaan')
  localStorage.removeItem('PeriodeProgram')
  localStorage.removeItem('Provinsi')
  localStorage.removeItem('TglLahir')
  localStorage.removeItem('ThnLahir')
  localStorage.removeItem('step_status')
  localStorage.removeItem('namaProvinsi')
  localStorage.removeItem('namaKota')
  localStorage.removeItem('namaCabang')
}

export const ClearLocalStorageStep2 = () => {
  localStorage.removeItem('Provinsi')
  localStorage.removeItem('Kota')
  localStorage.removeItem('Cabang')
  localStorage.removeItem('Pekerjaan')
  localStorage.removeItem('Gaji')
  localStorage.removeItem('JamMasukKantor')
  localStorage.removeItem('JamKeluarKantor')
  localStorage.removeItem('JHT')
  localStorage.removeItem('PeriodeProgram')
  localStorage.removeItem('NoVerifikasiSMS')
}


export const ClearLocalStorageStep1 = () => {
  localStorage.removeItem('Email')
  localStorage.removeItem('NoPonsel')
  // localStorage.removeItem('Alamat')
  localStorage.removeItem('formError')
}

export const ClearForm = () => {
  localStorage.removeItem('formError')
}


// WEBPACK FOOTER //
// ./src/lib/clearLocalStorage.js